var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitelisting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 90 90",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.983 32.802 c -0.057 0 -0.114 -0.002 -0.171 -0.007 c -0.621 -0.053 -1.181 -0.393 -1.516 -0.919 l -5.609 -8.814 C 8.094 22.13 8.368 20.894 9.3 20.301 c 0.933 -0.593 2.168 -0.318 2.761 0.614 l 4.204 6.605 l 14.91 -16.391 c 0.743 -0.819 2.007 -0.877 2.825 -0.134 c 0.817 0.743 0.877 2.008 0.134 2.825 L 17.462 32.148 C 17.082 32.566 16.543 32.802 15.983 32.802 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(70,204,141)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 29.494 40.582 H 2 c -1.104 0 -2 -0.896 -2 -2 V 12.857 c 0 -1.104 0.896 -2 2 -2 h 19.593 c 1.104 0 2 0.896 2 2 s -0.896 2 -2 2 H 4 v 21.724 h 23.494 v -8.145 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 v 10.145 C 31.494 39.686 30.599 40.582 29.494 40.582 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(89,134,203)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 88 21.333 H 42.359 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 H 88 c 1.104 0 2 0.896 2 2 S 89.104 21.333 88 21.333 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(89,134,203)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 75.983 33.724 H 42.359 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 33.624 c 1.104 0 2 0.896 2 2 S 77.088 33.724 75.983 33.724 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(89,134,203)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 29.494 79.525 H 2 c -1.104 0 -2 -0.896 -2 -2 V 51.801 c 0 -1.104 0.896 -2 2 -2 h 27.494 c 1.104 0 2 0.896 2 2 v 25.725 C 31.494 78.63 30.599 79.525 29.494 79.525 z M 4 75.525 h 23.494 V 53.801 H 4 V 75.525 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(89,134,203)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 88 60.276 H 42.359 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 H 88 c 1.104 0 2 0.896 2 2 S 89.104 60.276 88 60.276 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(89,134,203)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 75.983 72.667 H 42.359 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 33.624 c 1.104 0 2 0.896 2 2 S 77.088 72.667 75.983 72.667 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(89,134,203)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitelisting);
export default __webpack_public_path__ + "static/media/whitelisting.e2936bc1544dd18d8ced8959d752fa63.svg";
export { ForwardRef as ReactComponent };